import { type IPracticeMigration } from '@principle-theorem/practice-migrations/interfaces';
import { type WithRef } from '@principle-theorem/shared';

type CachedQuery = Promise<unknown[]>;

export class PostgresQueryCache {
  private static _cache = new WeakMap<
    WithRef<IPracticeMigration>,
    Map<string, CachedQuery>
  >();

  static get<T>(
    migration: WithRef<IPracticeMigration>,
    key: string,
    queryFn: () => Promise<T[]>
  ): Promise<T[]> {
    let queryCache = this._cache.get(migration);
    if (!queryCache) {
      queryCache = new Map<string, CachedQuery>();
      this._cache.set(migration, queryCache);
    }

    const cachedQuery = queryCache.get(key);
    if (cachedQuery) {
      return cachedQuery as Promise<T[]>;
    }

    const results = queryFn().catch((error) => {
      queryCache.delete(key);
      throw error;
    });
    queryCache.set(key, results);
    return results;
  }
}
